import type { NavLink } from 'Components/Layout/DrawerMenu/types'
import BasicLayout from 'Components/Layout/Templates/BasicLayout'
import CodespaceRoot from 'Services/ControlDataManagement/Features/Codespace'
import RefundCodeRoot from 'Services/ControlDataManagement/Features/RefundCode'
import ZoneRoot from 'Services/ControlDataManagement/Features/Zone'
import { isHslUser } from 'Services/common/Features/User/userSlice'
import useTypedSelector from 'Store'
import { CONTROL_DATA_MANAGEMENT_ROOT_URL, LOGIN_PAGE_PATH } from 'Util/constants'
import ProtectedRoute from 'Util/ProtectedRoute'
import CodeIcon from '@mui/icons-material/Code'
import PaidIcon from '@mui/icons-material/Paid'
import WebhookIcon from '@mui/icons-material/Webhook'
import { Navigate, Route, Routes } from 'react-router-dom'
import { t } from 'ttag'

function ControlDataManagement() {
  const { user } = useTypedSelector(state => state.user)

  const defaultMenuBarNavLinks: NavLink[] = [
    {
      title: t`Zones`,
      link: `${CONTROL_DATA_MANAGEMENT_ROOT_URL}/zones`,
      icon: <WebhookIcon fontSize="small" />
    },
    {
      title: t`Codespaces`,
      link: `${CONTROL_DATA_MANAGEMENT_ROOT_URL}/codespaces`,
      icon: <CodeIcon fontSize="small" />
    }
  ]

  const hslMenuBarNavLinks: NavLink[] = [
    {
      title: t`Zones`,
      link: `${CONTROL_DATA_MANAGEMENT_ROOT_URL}/zones`,
      icon: <WebhookIcon fontSize="small" />
    },
    {
      title: t`Refund codes`,
      link: `${CONTROL_DATA_MANAGEMENT_ROOT_URL}/refund-codes`,
      icon: <PaidIcon fontSize="small" />
    },
    {
      title: t`Codespaces`,
      link: `${CONTROL_DATA_MANAGEMENT_ROOT_URL}/codespaces`,
      icon: <CodeIcon fontSize="small" />
    }
  ]

  const menuBarNavLinks = isHslUser(user) ? hslMenuBarNavLinks : defaultMenuBarNavLinks

  return (
    <Routes>
      <Route element={<BasicLayout menuBarNavLinks={menuBarNavLinks} />} path="/">
        <Route index element={<Navigate to="zones/" />} />
        <Route path="/zones/*" element={<ZoneRoot />} />
        <Route
          element={
            <ProtectedRoute
              isAuthenticated={true}
              isAllowed={isHslUser(user)}
              authenticationPath={LOGIN_PAGE_PATH}
              restrictedPath={'/'}
            />
          }
        >
          <Route path="/refund-codes/*" element={<RefundCodeRoot />} />
        </Route>
        <Route path="/codespaces/*" element={<CodespaceRoot />} />
      </Route>
    </Routes>
  )
}

export default ControlDataManagement
